<template>
  <div>
    <template v-if="permissionDetail">
      <topsearch title="Özelleştirilmiş Raporlar" />
      <ReportList />
    </template>
  </div>
</template>

<script>
import ReportList from "../components/Datatable/ReportList";

export default {
  name: "list",
  components: { ReportList },
  data() {
    return {
      table: "leads",
      permissionMap: [],
      tableInfo: {},
    };
  },
  computed: {
    permissionDetail() {
      return this.$root.cache.permissions.find((e) => e.table == this.table);
    },
  },
};
</script>
